//removeIf(production)
const Dropzone = require('../../external/dropzone/dropzone.min.js');
//endRemoveIf(production)

class ClaroluzDropzone {
    private uploaderSelector: string;
    private previewTemplateId: string;
    private template: any;
    private options: any;
    public dropzone: any;

    constructor(uploaderSelector: string, previewTemplateId: string, options?: any) {
        this.uploaderSelector = uploaderSelector;
        this.previewTemplateId = previewTemplateId;
        this.options = options;

        this.validateUploaderSelector();
        this.validatePreviewTemplateId();
        this.setOptions();

        this.dropzone = new Dropzone(uploaderSelector, this.options);
    }

    private validateUploaderSelector(): boolean {
        if (!this.uploaderSelector) {
            throw new Error('Uploader selector not found');
        }

        if (typeof this.uploaderSelector !== 'string') {
            throw new Error('Uploader selector is not a string');
        }

        if (this.uploaderSelector.charAt(0) !== '.' && this.uploaderSelector.charAt(0) !== '#') {
            throw new Error('Uploader selector must start with "." or "#"');
        }

        return true;
    }

    private validatePreviewTemplateId(): boolean {
        if (!this.previewTemplateId) {
            throw new Error('Preview template id not found');
        }

        if (typeof this.previewTemplateId !== 'string') {
            throw new Error('Preview template id is not a string');
        }

        if (this.previewTemplateId.charAt(0) === '.') {
            throw new Error('Preview template id must not start with "."');
        }

        if (this.previewTemplateId.charAt(0) === '#') {
            this.previewTemplateId = this.previewTemplateId.substring(1);
        }

        if (!document.getElementById(this.previewTemplateId)) {
            throw new Error('No template found');
        }

        this.template = document.getElementById(this.previewTemplateId)!.innerHTML;

        return true;
    }

    private setOptions() {
        if (this.options && this.options instanceof Object) {
            this.options.previewTemplate = this.template;
        }
    }
}

//removeIf(production)
export default ClaroluzDropzone;
//endRemoveIf(production)